import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import List from "@material-ui/core/List";
import firebase from "firebase";

// Libraries
import db, { storage } from "../../../firebase/firebase";

// Icons
import IconButton from "@material-ui/core/IconButton";
import Button from '@material-ui/core/Button';
import DeleteIcon from "@material-ui/icons/Delete";
import LinkIcon from "@material-ui/icons/Link";
import CloseIcon from "@material-ui/icons/Close";
import { Avatar } from "@material-ui/core";

// MUI
import { Grid } from "@material-ui/core";
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
// Styling
import classes from "./Campaign.module.css";
import FireflyAnimation from "../../../hooks/Animations/FireflyAnimation";


// Components
import Modal from "../../../hooks/Modal/Modal";
import CampaignInviteModalContent from "./partials/CampaignInviteModalContent";
import DisplayCampaigns from "./DisplayCampaigns/DisplayCampaigns";
import InlineEdit from "../../../hooks/InlineEdit/InlineEdit";

//Store
import {
  selectChannelId,
  selectChannelInvitationUid,
  channelLogout,
  setChannelName,
} from "../../../store/reducers/appSlice";
import { selectUser } from "../../../store/reducers/userSlice";
import ConfirmDialog from "../../../hooks/Dialogs/ConfirmDialog";

function Campaign() {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector(selectUser);
  const activeCampaign = useSelector(selectChannelId);
  const activeInvitationUid = useSelector(selectChannelInvitationUid);

  const [inputName, setInputName] = useState("");
  const [characters, setCharacters] = useState(null);
  const [campaign, setCampaign] = useState(null);
  const [campaignData, setCampaignData] = useState({ campaigns: [] });
  const [open, setOpen] = React.useState(false);
  const [characterModalOpen, setCharacterModalOpen] = React.useState(false);
  const confirmOpen = open;
  const confirmCharacterModalOpen = characterModalOpen;

  const toggleModal = () => {
    setOpen(!open);
  };

  const toggleCharacterModalHandler = () => {
    setCharacterModalOpen(!characterModalOpen);
  }




  const [roominvitation, setRoominvitation] = useState(null);
  const [roominvitationModalOpen, setRoominvitationModalopen] = useState(false);

  // Configure the campaign invitation modal
  const campaignInviteModalContent = (
    <CampaignInviteModalContent invite={roominvitation} />
  );
  const roominvitationModalConfig = {
    title: "Copy invite link to clipboard",
    content: campaignInviteModalContent,
  };

  // Toggle invite modal visibility
  const toggleRoominvitationDialogue = () => {
    setRoominvitationModalopen(!roominvitationModalOpen);
  };

  // Invite link button onClick
  const handleInviteLink = () => {
    toggleRoominvitationDialogue();
  };

  const handleRemoveCampaign = () => {
    db.collection("channels")
      .doc(activeCampaign)
      .delete()
      .then(function () {
        history.push("/");
        dispatch(channelLogout());
        console.log("campaign room successfully deleted!");
      })
      .catch(function (error) {
        console.error("Error removing document: ", error);
      });
  };

  const handleRemoveUser = (userID) => {
    db.collection("channels")
      .doc(activeCampaign)
      .update({
        channelUsers: firebase.firestore.FieldValue.arrayRemove(userID),
      })
      .then(function () {
        console.log("user successfully deleted!");
      })
      .catch(function (error) {
        console.error("Error removing document: ", error);
      });
  };

  const handleUpdateCampaignName = (updateValue) => {
    db.collection("channels")
      .doc(activeCampaign)
      .update({ channelName: updateValue });
    dispatch(setChannelName(updateValue));
  };

  const handleBackButtonClick = () => {
    history.push("/");
  };

  // Upon character portrait file-input change
  const uploadCharacterPortrait = (e) => {
    let image = e.target.files[0];
    let path = `campaigns/` + activeCampaign;
    let imagePath = path + "/" + image.name;

    const uploadTask = storage.ref(imagePath).put(image);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // progress function ...
        // const progress = Math.round(
        //     (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        // );
        //this.setState({ progress });
      },
      (error) => {
        // Error function ...
        console.log(error);
      },
      () => {
        // complete function ...
        storage
          .ref(path)
          .child(image.name)
          .getDownloadURL()
          .then((url) => {
            console.log("uploaded image url " + url);
            updateCampaignPortrait(url);
          });
      }
    );
  };

  const updateCampaignPortrait = (portrait) => {
    // dispatch(changeCharacterPortrait(portrait));
    db.collection("channels")
      .doc(activeCampaign)
      .update({ channelImage: portrait });
  };

  // Gets Char Portraits only when component mounts
  useEffect(() => {
    let campaignUrls = { campaigns: [] };
    let storageRef = storage.ref();
    let listRef = storageRef.child("/resources/images/rooms/");
    listRef
      .listAll()
      .then(function (result) {
        result.items.forEach(function (item) {
          item.getDownloadURL().then((result) => {
            campaignUrls.campaigns.push(result);
            setCampaignData(campaignUrls);
          });
        });
      })
      .catch(function (error) { });
  }, []);

  useEffect(() => {
    if (activeCampaign) {
      let docRef = db.collection("channels").doc(activeCampaign);
      let fetchActiveCampaign = docRef.onSnapshot(function (doc) {
        if (doc.exists) {
          setCampaign(doc.data());
          setInputName(doc.data().channelName);
        }
        else {
          console.log('No active Campaigns');
        }
      });
      setRoominvitation(activeInvitationUid);
      return () => {
        fetchActiveCampaign();
      };
    }
  }, [activeCampaign, activeInvitationUid]);

  useEffect(() => {
    function getData() {
      if (campaign.channelUsers) {
        let docRef = db.collection("users");
        docRef
          .where(
            firebase.firestore.FieldPath.documentId(),
            "in",
            campaign.channelUsers
          )
          .onSnapshot((snapshot) =>
            setCharacters(
              snapshot.docs.map((doc) => ({
                id: doc.id,
                user: doc.data(),
              }))
            )
          );
      }
    }
    if (campaign) {
      getData();
    }
  }, [campaign]);

  let profile = <div className={classes.wallpaper}></div>;
  if (campaign) {
    if (characters) {
      profile = (
        <div className={classes.wallpaper}>
          <div
            className={classes.profile__back__button}
            onClick={handleBackButtonClick}
          >
            <IconButton>
              <CloseIcon color="primary" />
            </IconButton>
          </div>
          <Grid
            container
            spacing={3}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Grid item xl={12} xs={12}>
              <div className={classes.profile__spheres}>
                <img
                  src={campaign.channelImage}
                  className={classes.profile__portrait__img}
                  alt="Logo"
                  loading="lazy"
                />
                <div className={classes.button__container}>
                  <DisplayCampaigns
                    imageList={campaignData.campaigns}
                    onCLickAction={updateCampaignPortrait}
                    fileUploadDestination={uploadCharacterPortrait}
                  />
                </div>
              </div>
            </Grid>
          </Grid>

          <div className={classes.gradient__box}>
            <form className={classes.form__group}>
              <Grid
                container
                spacing={3}
                direction="column"
                alignItems="center"
                justify="center"
              >
                <Grid item xs={12} xl={12}>
                  <div className={classes.TextFieldPadding}>
                    <InlineEdit
                      text={inputName}
                      
                      label="Campaign Name"
                      onSetText={(text) => {
                        setInputName(text);
                        handleUpdateCampaignName(text);
                      }}
                    />
                  </div>

                  <List dense className={classes.root}>
                    {Object.keys(characters).map((username) => {
                      return (
                        <ListItem key={username} button>
                          <ListItemAvatar>
                            <Avatar
                              alt={`Avatar n°${username + 1}`}
                              src={characters[username].user.portrait}
                            />
                          </ListItemAvatar>
                          <ListItemText primary={characters[username].user.avatar} />
                          <ListItemSecondaryAction>
                            {(characters[username].id === user.uid ||
                              campaign.channelOwner === user.uid) && (
                                <IconButton onClick={() => toggleCharacterModalHandler()}
                                //this is currently opening the delete room modal

                                >
                                  <ConfirmDialog
                                    title="Delete user from room?"
                                    open={confirmCharacterModalOpen}
                                    toggleModal={toggleCharacterModalHandler}
                                    onConfirm={() => handleRemoveUser(characters[username].id)}
                                  >
                                    Are you sure you want to remove this character from the room?
                      </ConfirmDialog>
                                  <DeleteIcon fontSize="medium" color="primary"></DeleteIcon>
                                </IconButton>
                              )}
                          </ListItemSecondaryAction>
                        </ListItem>
                      );
                    })}
                  </List>
                  <Grid item xs={12} xl={12}>
                    <Button
                      onClick={handleInviteLink}
                      className={classes.TextField__button}
                      startIcon={<LinkIcon fontSize="medium" color="primary" />}
                    >
                      Invite to campaign room
                  </Button>
                  </Grid>

                </Grid>
                {campaign.channelOwner === user.uid && (
                  <Grid item xs={12} xl={12}>
                    <IconButton
                      className={classes.delete__button}
                      onClick={() => toggleModal()}
                    >
                      <ConfirmDialog
                        title="Delete Campaign room?"
                        open={confirmOpen}
                        toggleModal={toggleModal}
                        onConfirm={handleRemoveCampaign}
                      >
                        Are you sure you want to delete this campaign room?
                      </ConfirmDialog>
                      <DeleteIcon fontSize="medium" color="primary" />
                    </IconButton>
                  </Grid>
                )}
              </Grid>
            </form>
            <FireflyAnimation></FireflyAnimation>
          </div>
        </div>
      );
    }
  }

  return (
    <div className={classes.profile}>
      <div className={classes.grey__background}>
        {profile}
        <Modal
          open={roominvitationModalOpen}
          openToggle={toggleRoominvitationDialogue}
          config={roominvitationModalConfig}
        />
      </div>
    </div>
  );
}

export default Campaign;
